import { launchURL, sendEvent } from './jweb';

/**
 * Sends an event to the Native App for show or hiding the Customer Engagement Center
 * @param {boolean} show Display (true) or hide (false) tile
 */
export const sendShowHideCECEvent = show => {
  const data = {
    Show: show
  };
  sendEvent('ShowHideCEC', data);
};

/**
 * Sends an event to the Native App for show hpx banner
 */
export const sendShowHpxBannerEvent = (data = {}) => {
  sendEvent('ShowHpxBanner', data);
};

/**
 * Sends an event to the Native App for launching HPX
 */
export const sendLaunchHpxEvent = (data = {}) => {
  sendEvent('LaunchHpx', data);
};

/**
 * Sends an event to the Native App to trigger the DSP workflow.
 * @param {string} jumpId Jump ID for the UDL
 */
export const sendShowDSPEvent = jumpId => {
  const data = {
    JumpID: jumpId
  };
  sendEvent('ShowDSP', data);
};

/**
 * Sends an event to the Native App to launch URL.
 * @param {string} url Url to Load
 */
export const sendLaunchUrlEvent = (url, nativeNavBar, useExternalBrowser=false) => {
  launchURL(url, nativeNavBar,useExternalBrowser);
};

/**
 * Sends an event to the Native App to trigger the Account Creation workflow.
 * @param {string} jumpId Jump ID for the UDL
 */
export const sendShowCreateAccountEvent = jumpId => {
  const data = {
    JumpID: jumpId
  };
  sendEvent('ShowCreateAccount', data);
};

/**
 * Sends an event to the Native App to trigger the Sign In workflow.
 * @param {*} jumpId Jump ID for the UDL
 */
export const sendShowSignInEvent = jumpId => {
  const data = {
    JumpID: jumpId
  };
  sendEvent('ShowSignIn', data);
};

/**
 * Sends an event to the JWeb to close the most recent Service Routing Plugin that was launched.
 */
export const sendJarvisEventFinishedEvent = (data = {}) => {
  sendEvent('jarvisEventFinished', data);
  sendEvent('com.hp.jarvis.servicerouting.serviceinstance.closed', data);
  sendJwebCloseEvent();
};

/**
 * Sends an event to the Native App to let Native know that Web Application is ready to receive events.
 */
export const sendWebAppIsReadyForEvent = () => {
  const data = {};
  sendEvent('webAppIsReady', data);
};

/**
 * Sends an event to the Native App to trigger the Hp+ second chance workflow.
 * @param {string} jumpId Jump ID for the UDL
 */
export const sendShowHPPlusConversionEvent = eventData => {
  const data = {
    ...eventData
  };
  sendEvent('ShowHPPlusConversion', data);
};

/**
 * Sends an event to the native app to launch a native app tile.
 */
export const sendShowLaunchTileEvent = (data = {}) => {
  sendEvent('LaunchTile', data);
};

/**
 * Sends an event to the native app to launch a JWEB app tile.
 */
export const sendJwebLaunchEvent = (data = {}) => {
  sendEvent('jwebServiceRouterLaunched', data);
};

/**
 * Sends an event to the native app to Close a JWEB app tile.
 */
export const sendJwebCloseEvent = (data = {}) => {
  sendEvent('jwebServiceRouterClosed', data);
};
/**
 * Sends an event to the native app to open a deeplink to another app
 * or within existing app
 */
export const sendDeepLinkEvent = (data = {}) => {
  sendEvent('DeepLink', data);
};
